 import { bool, func, number, oneOfType, shape, string } from 'prop-types';
import React, { memo, useEffect, useRef, useState } from 'react';
import { useAtp } from '../../../../cap/hooks/useATP';
import ProductTile from '../ProductTile';
import { PRODUCT_TILE_MOUNT_REACT } from '../../../utils/commonUtils';
import { PRODUCT_TILE_VARIANT } from '../../../constants';

const AddToCartProductTileReact = ({ cardData = {
    catclass: '',
    showonlinecatalog: 'YES',
    disableaddtocartoption: 'NO',
    catsku: '',
    inventory: ''
}, handleClick = () => {}, trackAnalytics = () => {}, handleAddToCartClickAnalytics = () => {}, isCoachmarkEnabled = true, isReplaceItem = false, variant = PRODUCT_TILE_VARIANT.GRID_VIEW, tileStatus = '',replaceSku=''}) => {
    const currentNode = useRef();
    const { handleATP } = useAtp();
    const [isLoading, setIsLoading] = useState(false);

    // if status is passed in props will use that else will calculate
    const status = tileStatus || handleATP({
        catsku: cardData?.catsku,
        inventoryDataObj: cardData?.inventory,
        showonlinecatalog: cardData?.showonlinecatalog,
        disableaddtocartoption: cardData?.disableaddtocartoption,
        pcAvailability: cardData?.pc_availability
    });

    useEffect(() => {
        if (currentNode?.current) {
            currentNode.current.dataset.productdata = JSON.stringify({ catclass: cardData?.catclass });
        }
    }, [cardData?.catclass]);

    return (
        <div ref={currentNode} className={isLoading ? 'pdp__root-isloading' : PRODUCT_TILE_MOUNT_REACT}>
            <ProductTile
                tileDetails={cardData}
                tileState={status}
                handleClick={handleClick}
                trackAnalytics={trackAnalytics}
                handleAddToCartClickAnalytics={handleAddToCartClickAnalytics}
                isCoachmarkEnabled={isCoachmarkEnabled}
                isReplaceItem={isReplaceItem}
                variant={variant}
                replaceSku={replaceSku}
            />
        </div>
    );
};

AddToCartProductTileReact.propTypes = {
    cardData: shape({
        catclass: oneOfType([number, string]),
        showonlinecatalog: string,
        disableaddtocartoption: string,
        catsku: oneOfType([number, string]),
        inventory: string
    }),
    handleClick: func,
    trackAnalytics: func,
    handleAddToCartClickAnalytics: func,
    isCoachmarkEnabled: bool,
    isReplaceItem: bool,
    variant: string,
    tileStatus: string
};

export default memo(AddToCartProductTileReact);
